import { MFNames } from '@packages/config/MFNames';
import { getChannel } from '@packages/service-worker/src/utils/getChanelMessage';
import { delay } from '@packages/utils/delay';
import { type FC, useEffect } from 'react';

export const GlobalSuspenseLoader: FC = () => {
	useEffect(() => {
		return () => {
			if (!window.appInit) {
				window.appInit = true;
				const channel = getChannel();
				channel.postMessage({
					serviceWorker: {
						message: 'initFileStore',
						messageData: {
							appManifestUrl: getAppManifestUrl(),
						},
					},
				});
				delay(100).then(() =>
					document.documentElement.setAttribute(
						'app-is-loading',
						'false',
					),
				);
			}
		};
	}, []);
	return null;
};

function getAppManifestUrl() {
	const appName = window.getAppEnv('appName');

	const mfManifestUrl = window.getMfManifestUrl(MFNames[appName]);

	if (mfManifestUrl) {
		return mfManifestUrl;
	}
	return '';
}
